import {Component, EventEmitter, Input, Output} from '@angular/core';
import {AbstractControl, FormArray, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {EnumData} from "../../../../api/enum/enum.model";

@Component({
    selector: 'app-guardian-section',
    imports: [ReactiveFormsModule],
    templateUrl: './guardian-section.component.html'
})
export class GuardianSectionComponent {
    @Input() formArray!: FormArray;
    @Input() relations: EnumData[] = [];
    @Output() add = new EventEmitter<void>();
    @Output() remove = new EventEmitter<number>();
    @Output() numbersOnly = new EventEmitter<any>();

    asFormGroup(control: AbstractControl): FormGroup {
        return control as FormGroup;
    }
}
